// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.webviewerPlayBackControlWrapper {
  left: 50%;
  bottom: 16px;
  display: flex;
  position: absolute;
  transform: translateX(-50%);
  align-items: center;
  flex-direction: column;
  justify-content: center;
  z-index: 20;
}
.webviewerPlayBackControlWrapper .playBack {
  height: 36px;
  display: flex;
  align-items: center;
  border-radius: 16px;
  margin-bottom: 10px;
  background-color: white;
  padding: 0 4px;
}
.webviewerPlayBackControlWrapper .playBack .btnItemStyle1 {
  background-color: #f3f4f5;
  border-radius: 14px 4px 4px 14px;
  width: 34px;
  height: 28px;
  min-width: 28px;
  margin: 4px 2px;
}
.webviewerPlayBackControlWrapper .playBack .btnItemStyle2 {
  background-color: #f3f4f5;
  border-radius: 4px;
  width: 34px;
  height: 28px;
  min-width: 28px;
  margin: 4px 2px;
}
.webviewerPlayBackControlWrapper .playBack .btnItemStyle3 {
  background-color: #f3f4f5;
  border-radius: 4px 14px 14px 4px;
  width: 34px;
  height: 28px;
  min-width: 28px;
  margin: 4px 2px;
}
.webviewerPlayBackControlWrapper .keyframeControl {
  bottom: 8px;
  height: 106px;
  display: flex;
  min-width: 500px;
  box-shadow: none;
  align-items: center;
  border-radius: 10px;
  background-color: white;
}
.webviewerPlayBackControlWrapper .keyframeControl .keyframePlane {
  color: #444444;
  width: 100%;
  height: 70px;
  margin: 0px 15px;
  display: flex;
  box-sizing: border-box;
  user-select: none;
  flex-direction: row;
  justify-content: space-between;
}
.webviewerPlayBackControlWrapper .keyframeControl .keyframePlane .keyframe {
  position: relative;
  text-align: center;
  flex-direction: column;
  cursor: pointer;
}
.webviewerPlayBackControlWrapper .keyframeControl .keyframePlane .keyframe .keyframeIconBox {
  padding: 2px 8px;
  border-radius: 6px;
  background-color: white;
}
.webviewerPlayBackControlWrapper .keyframeControl .keyframePlane .keyframe .keyframeIconBox .keyframeIcon {
  color: #caccce;
  width: 6px;
  height: 16px;
  margin: 8px 0;
  border-radius: 20px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.webviewerPlayBackControlWrapper .keyframeControl .keyframePlane .keyframe .keyframeNum {
  width: 13px;
  display: inline-block;
  font-size: smaller;
  overflow: hidden;
}
.webviewerPlayBackControlWrapper .keyframeControl .keyframePlane .keyframe .maxSpan {
  position: absolute;
  left: 0;
}
.playerPopover .ant-popover-content {
  top: 30px;
  left: 20px;
}
.selectByteUpperOrLower {
  display: flex;
  flex-direction: row;
  position: absolute;
  right: -28px;
  top: 0px;
}
.selectByteUpperOrLower .wrap {
  width: 80px;
  height: 32px;
  background-color: white;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin: 0 4px;
  transition: 0.3s;
}
.selectByteUpperOrLower .wrap span {
  font-weight: 500;
  font-size: 14px;
  color: black;
}
.selectByteUpperOrLower .active {
  background-color: #0076FF;
}
.selectByteUpperOrLower .active span {
  color: white;
}
.combineOrSeparateWrap {
  display: flex;
  flex-direction: row;
  position: absolute;
  left: -4px;
  top: 1px;
}
.combineOrSeparateWrap .wrap {
  width: 68px;
  height: 32px;
  background-color: white;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin: 0 4px;
  transition: 0.3s;
}
.combineOrSeparateWrap .wrap span {
  font-weight: 500;
  font-size: 14px;
  color: black;
}
.combineOrSeparateWrap .active {
  background-color: #0076FF;
}
.combineOrSeparateWrap .active span {
  color: white;
}
.combineOrSeparateWrap .disable {
  background-color: gray;
  color: white;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/View/Option/Components/PlayBackControl/index.less"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;AACF;AAVA;EAcI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AADJ;AAnBA;EAuBM,yBAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AADN;AA3BA;EAgCM,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AAFN;AAnCA;EAyCM,yBAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AAHN;AA3CA;EAmDI,WAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AALJ;AArDA;EA6DM,cAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;AALN;AAhEA;EAwEQ,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AALR;AAtEA;EA8EU,gBAAA;EACA,kBAAA;EACA,uBAAA;AALV;AA3EA;EAmFY,cAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;AALZ;AArFA;EA+FU,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;AAPV;AA3FA;EAsGU,kBAAA;EACA,OAAA;AARV;AAiBA;EAEI,SAAA;EACA,UAAA;AAhBJ;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;AAlBF;AAaA;EAQI,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;AAlBJ;AACA;EAoBM,gBAAA;EACA,eAAA;EACA,YAAA;AAlBN;AAJA;EA2BI,yBAAA;AApBJ;AAPA;EA8BM,YAAA;AApBN;AAyBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;AAvBF;AAkBA;EAQI,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;AAvBJ;AAMA;EAoBM,gBAAA;EACA,eAAA;EACA,YAAA;AAvBN;AACA;EA2BI,yBAAA;AAzBJ;AAFA;EA8BM,YAAA;AAzBN;AALA;EAmCI,sBAAA;EACA,YAAA;EACA,mBAAA;AA3BJ","sourcesContent":[".webviewerPlayBackControlWrapper {\n  left: 50%;\n  bottom: 16px;\n  display: flex;\n  position: absolute;\n  transform: translateX(-50%);\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  z-index: 20;\n\n\n\n  .playBack {\n    height: 36px;\n    display: flex;\n    align-items: center;\n    border-radius: 16px;\n    margin-bottom: 10px;\n    background-color: white;\n    padding: 0 4px;\n\n    .btnItemStyle1 {\n      background-color: rgb(243, 244, 245);\n      border-radius: 14px 4px 4px 14px;\n      width: 34px;\n      height: 28px;\n      min-width: 28px;\n      margin: 4px 2px;\n    }\n\n    .btnItemStyle2 {\n      background-color: rgb(243, 244, 245);\n      border-radius: 4px;\n      width: 34px;\n      height: 28px;\n      min-width: 28px;\n      margin: 4px 2px;\n    }\n\n    .btnItemStyle3 {\n      background-color: rgb(243, 244, 245);\n      border-radius: 4px 14px 14px 4px;\n      width: 34px;\n      height: 28px;\n      min-width: 28px;\n      margin: 4px 2px;\n    }\n  }\n\n  .keyframeControl {\n    bottom: 8px;\n    height: 106px;\n    display: flex;\n    min-width: 500px;\n    box-shadow: none;\n    align-items: center;\n    border-radius: 10px;\n    background-color: white;\n\n    .keyframePlane {\n      color: #444444;\n      width: 100%;\n      height: 70px;\n      margin: 0px 15px;\n      display: flex;\n      box-sizing: border-box;\n      user-select: none;\n      flex-direction: row;\n      justify-content: space-between;\n\n      .keyframe {\n        position: relative;\n        text-align: center;\n        flex-direction: column;\n        cursor: pointer;\n\n        .keyframeIconBox {\n          padding: 2px 8px;\n          border-radius: 6px;\n          background-color: white;\n\n          .keyframeIcon {\n            color: #caccce;\n            width: 6px;\n            height: 16px;\n            margin: 8px 0;\n            border-radius: 20px;\n            position: relative;\n            left: 50%;\n            transform: translateX(-50%);\n          }\n        }\n\n        .keyframeNum {\n          width: 13px;\n          display: inline-block;\n          font-size: smaller;\n          overflow: hidden;\n        }\n\n        .maxSpan {\n          position: absolute;\n          left: 0;\n\n\n        }\n      }\n    }\n  }\n}\n\n.playerPopover {\n  .ant-popover-content {\n    top: 30px;\n    left: 20px;\n  }\n}\n\n.selectByteUpperOrLower {\n  display: flex;\n  flex-direction: row;\n  position: absolute;\n  right: -28px;\n  top: 0px;\n\n  .wrap {\n    width: 80px;\n    height: 32px;\n    background-color: white;\n    border-radius: 8px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    margin: 0 4px;\n    transition: .3s;\n\n    span {\n      font-weight: 500;\n      font-size: 14px;\n      color: black;\n    }\n  }\n\n  .active {\n    background-color: #0076FF;\n\n    span {\n      color: white;\n    }\n  }\n}\n\n.combineOrSeparateWrap {\n  display: flex;\n  flex-direction: row;\n  position: absolute;\n  left: -4px;\n  top: 1px;\n\n  .wrap {\n    width: 68px;\n    height: 32px;\n    background-color: white;\n    border-radius: 8px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    margin: 0 4px;\n    transition: .3s;\n\n    span {\n      font-weight: 500;\n      font-size: 14px;\n      color: black;\n    }\n  }\n\n  .active {\n    background-color: #0076FF;\n\n    span {\n      color: white;\n    }\n  }\n\n  .disable {\n    background-color: gray;\n    color: white;\n    cursor: not-allowed;\n  }\n}\n\n@primary-color: black;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
